/**
 * shaders/ShaderLayer
 */


import path from 'path';

import { toVar } from './core';
import PointsShader from './points-shader';
import ColorManager from '../core/color-manager';


export default class ShaderLayer {

    constructor(db, config) {
        this.db = db;
        this.layers = db.fields[config.fields.primary].uniqueValues;
        this.layerShader = new PointsShader(this.layers, config);

        const uniformProps = {
            dataTileWidth: db.imageSize.width,
            fade: config.shader.fade,
            filter: this.layerShader.checksToBits(
                config.layers || this.layers.reduce((a,l) => (a[l] = true) && a, {})
            ),
            seed: config.shader.seed,
            ...config.props,
        };

        config.fields.all.forEach(field => uniformProps[toVar(field)] = { image: db.images[field].image });

        const uniformPropTypes = config.fields.all.reduce((a,f) => (a[toVar(f)] = 'sampler2D') && a, {});

        console.log(config.palette);

        const fragmentShaders = Object.keys(config.palette).map(name => ({
            name,
            shader: this.layerShader.getFragmentShader(new ColorManager(config.palette[name])),
        }));

        this.tileLayer = new L.tileLayer.regl({
            fragmentShader: fragmentShaders,
            limits: [ { zoom: config.maxZoom },  { zoom: config.maxZoom } ],
            tileUrls: [path.join(config.basePath, '/tiles/{z}/{x}/{y}.png')],
            uniformProps,
            uniformPropTypes,
        });

        this.props = config.props;
    }


    /**
     * @param Object layers
     */
    setLayers(layers) {
        this.tileLayer.setUniformProperty({
            filter: this.layerShader.checksToBits(layers),
        });
    }


    /**
     * @param String name
     */
    setPalette(name) {
        this.tileLayer.setShader(name);
    }


    /**
     * @param Object props
     */
    setUniformProperties(props) {
        this.tileLayer.setUniformProperty(props);

        Object.keys(props).forEach(prop => {
            this.props[prop] = props[prop];
        });
    }

}
